import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DpfService } from 'src/app/core/services/dpf.service';
import { GoogleAuthService } from 'src/app/core/services/google-auth.service';
import { AppStateService } from 'src/app/core/services/app-state.service';
import { RouterPath } from '../../models';
import { DocsService } from 'src/app/views/docs/docs.service';

@Component({
    selector: 'app-signup-modal',
    templateUrl: './signup-modal.component.html',
    styleUrls: ['./signup-modal.component.scss'],
})
export class SignupModalComponent implements OnInit {
    @Output() closed = new EventEmitter<void>();
    @Output() switchToLoginEvent = new EventEmitter<void>();
    @Output() switchToOtp = new EventEmitter<void>();
    @Output() switchToSetProfile = new EventEmitter<void>();

    username = '';
    fullname = '';
    email = '';
    password = '';
    confirmPassword = '';
    isProfessional = false;
    agree = false;

    showPassword = false;
    showConfirmPassword = false;

    companies = [];
    company = '';
    otherCompany = '';
    organizationEmail = '';
    linkedinUrl = '';

    lang = 'en';

    protected readonly RouterPath = RouterPath;

    constructor(
        private googleAuth: GoogleAuthService,
        private dpfService: DpfService,
        private appStateService: AppStateService,
        private docsService: DocsService
    ) {}

    ngOnInit(): void {
        this.subscribeToLocaleChange();
        this.getCompanyUniversity();
    }

    subscribeToLocaleChange() {
        // Use unified 'locale' storage key with ISO language codes
        this.lang = sessionStorage.getItem('locale') || 'en';
        this.appStateService.localeObservable().subscribe((val) => {
            if (val) {
                this.lang = val;
            }
        });
    }

    getCompanyUniversity() {
        this.dpfService.getAllUniversity().subscribe((val) => {
            if (val?.status) {
                this.companies = val?.data;
                this.companies.push({ nameEn: 'Other' });
            }
        });
    }

    togglePassword() {
        this.showPassword = !this.showPassword;
    }

    toggleConfirmPassword() {
        this.showConfirmPassword = !this.showConfirmPassword;
    }

    close() {
        this.closed.emit();
    }

    isFormValid(): boolean {
        return (
            this.username.trim() &&
            this.fullname.trim() &&
            this.email.trim() &&
            this.password.trim() &&
            this.password === this.confirmPassword &&
            this.agree
        );
    }

    registerFail = false;
    usernameError = false;
    submitted = false;
    onSubmit() {
        this.submitted = true;
        if (this.isProfessional) {
            if (
                !(this.company || this.otherCompany) ||
                !this.organizationEmail ||
                !this.linkedinUrl
            ) {
                return;
            }
        }
        if (this.isFormValid()) {
            const body = {
                username: this.username,
                fullname: this.fullname,

                email: this.email,
                password: this.password,
                confirmPassword: this.confirmPassword,

                isProfessional: this.isProfessional,
                companyOrUniversity: this.company || null,
                otherOrganizationName: this.otherCompany || null,
                organizationEmail: this.organizationEmail || null,
                profileLink: this.linkedinUrl || null,
            };
            this.dpfService
                .newRegister(body, { type: 'EMAIL' })
                .subscribe((val) => {
                    if (val?.status) {
                        this.closed.emit();
                        this.switchToOtp.emit();
                        sessionStorage.setItem('email', this.email);
                    } else {
                        this.registerFail = true;
                        if (val.message.includes('10020')) {
                            this.usernameError = true;
                        }
                    }
                });
        }
    }

    userNameChange() {
        this.usernameError = false;
    }

    switchToLogin() {
        this.closed.emit();
        this.switchToLoginEvent.emit();
    }

    signupWithGoogle() {
        this.googleAuth.init(async (idToken) => {
            const body = { idToken };
            const res = await this.dpfService.loginWithGoogle(body);
            if (!res?.status) {
                return;
            }
            localStorage.setItem('token', res.data);
            await this.dpfService.authCheck(); // Call this after token is retrieved
            this.appStateService.nextTokenValue(true); // Call this after jwt is retrieved from authCheck()
            await this.docsService.acceptActivePoliciesIfNeeded(localStorage.getItem('userId'));
            const resp = await this.dpfService.checkProfile();
            if (resp?.status && resp?.data) {
                this.switchToSetProfile.emit();
            }
            this.closed.emit();
        });

        this.googleAuth.renderButton('googleBtn');
        this.googleAuth.promptOneTap();
    }
}
